import { reactive } from 'vue'
export const loadingStorage = reactive({
  loadingKeys: new Map<string, boolean>(),
  setLoading(key: string) {
    return this.loadingKeys.set(key, true)
  },
  hasLoading(key: string) {
    for (const [storedKey] of this.loadingKeys) {
      if (storedKey?.toLowerCase() === key?.toLowerCase()) {
        return true
      }
    }
    return false
  },
  clearAllLoading() {
    this.loadingKeys.clear()
  },
  clearSpecificLoading(keyPart: string) {
    for (const [key] of this.loadingKeys) {
      try {
        if (key?.toLowerCase() === keyPart?.toLowerCase()) {
          this.loadingKeys.delete(key)
        }
      } catch (e) {
        //error
      }
    }
  }
})
